module.exports = __webpack_public_path__ + "static/media/category.234e8221.svg";